import { ErrorBoundary } from "react-error-boundary";
import type { RouteObject } from "react-router";

import { ErrorPage } from "src/app/pages/ErrorPage/ErrorPage";
import { LoginPage } from "src/app/pages/LoginPage/LoginPage";
import ApaMSELoginPage from "src/app/pages/MSEntraLogin/ApaMSELoginPage";
import { NotFoundPage } from "src/app/pages/NotFoundPage/NotFoundPage";
import { UnauthorisedPage } from "src/app/pages/UnauthorisedPage/UnauthorisedPage";
import { AppLayout } from "../../../components/AppLayout";
import { authenticatedRouteLoader } from "../auth/authenticatedRouteLoader";
import { routes } from "../config/routes";
import { protectedRoutesConfig } from "../config/routesConfig";
import type { AppRouterConfig } from "../types/AppRouterConfig";
import type { AppRouterProps } from "../types/AppRouterProps";
import { BASE_PATH } from "../types/routerTypes";

export function wrapRoutesWithErrorBoundary(routes2: RouteObject[]): RouteObject[] {
    return routes2.map((route) => {
        const element = route.element ? <ErrorBoundary FallbackComponent={ErrorPage}>{route.element}</ErrorBoundary> : route.element;

        return {
            ...route,
            element,
        } as RouteObject;
    });
}

export const useAppRouterConfig = () => {
    // eslint-disable-next-line no-underscore-dangle
    const isMSEntraLogin = window.__RUNTIME_CONFIG__?.IDENTITY_SERVICE === "entra";

    const ApaRouterRoutes: RouteObject[] = wrapRoutesWithErrorBoundary([
        {
            path: `${BASE_PATH}/`,
            element: <AppLayout />,
            loader: authenticatedRouteLoader,
            errorElement: <ErrorPage error={new Error("Unknown error")} resetErrorBoundary={() => {}} />,
            children: [
                ...Object.keys(protectedRoutesConfig).map((routePath) => ({
                    path: routePath,
                    element: protectedRoutesConfig[routePath],
                })),
            ],
        },
        { path: routes.login.path, element: isMSEntraLogin ? <ApaMSELoginPage /> : <LoginPage /> },
        { path: routes.unauthorised.path, element: <UnauthorisedPage /> },
        { path: "*", element: <NotFoundPage /> },
    ]);
    const ApaRouterConfig: AppRouterConfig = { basename: BASE_PATH };

    const apaRouterConfig: AppRouterProps = {
        config: ApaRouterConfig,
        routes: ApaRouterRoutes,
    };
    return apaRouterConfig;
};
